import { render, staticRenderFns } from "./authenticateLayout.vue?vue&type=template&id=06c06ad4&scoped=true"
import script from "./authenticateLayout.vue?vue&type=script&lang=js"
export * from "./authenticateLayout.vue?vue&type=script&lang=js"
import style0 from "./authenticateLayout.vue?vue&type=style&index=0&id=06c06ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c06ad4",
  null
  
)

export default component.exports